import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { Kevlar2ConfigComponent } from './kevlar2-config.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule
    ],
    declarations: [
        Kevlar2ConfigComponent
    ],
    providers: [],
    exports: []
})
export class Kevlar2ConfigModule {}
